import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import React from 'react';
import { useGlobal } from 'reactn';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLegend,
  VictoryTooltip,
} from 'victory';
import Card from '../../common/card/Card';

dayjs.extend(quarterOfYear);

const Consumption = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (!selectedServiceAccount) {
    return <div>loading TODO</div>;
  }

  const { consumptionData } = selectedServiceAccount;

  return (
    <Card
      padded={true}
      title="Current Water Usage"
      {...rest}
      waterConsumptionColor
    >
      <VictoryChart scale={{ x: 'time' }}>
        <VictoryLegend
          x={150}
          y={10}
          orientation="horizontal"
          gutter={20}
          // colorScale={['#2A4E68', '#4C86B5']}
          colorScale={['#4C86B5', '#2A4E68']}
          data={[
            { name: 'Same Period Last Year' },
            { name: 'Current Consumption' },
          ]}
          style={{ labels: { fontSize: 12 } }}
        />
        {consumptionData.map(({ READ_DATE, CONS, COMPARE_CONS }, index) => {
          return (
            <VictoryGroup
              key={index}
              offset={20}
              // colorScale={['#2A4E68', '#4C86B5']}
              colorScale={['#4C86B5', '#2A4E68']}
              labels={(props) => {
                const { datum } = props;

                return `y: ${datum.y}`;
              }}
              labelComponent={<VictoryTooltip />}
            >
              <VictoryBar
                barWidth={18}
                data={[{ x: new Date(READ_DATE), y: COMPARE_CONS }]}
              />
              <VictoryBar
                barWidth={18}
                data={[{ x: new Date(READ_DATE), y: CONS }]}
              />
            </VictoryGroup>
          );
        })}
        <VictoryAxis
          tickFormat={(x) => {
            return `QTR${dayjs(x).quarter()} '${dayjs(x).format('YY')}`;
          }}
          style={{
            tickLabels: {
              fontSize: 8,
              padding: 2,
              marginLeft: 10,
              textAlign: 'center',
            },
          }}
        />
        <VictoryAxis
          dependentAxis
          label="Thousand Gallons"
          tickValues={[0, 5, 10, 15, 20]}
          style={{ axisLabel: { fontSize: 10 }, tickLabels: { fontSize: 8 } }}
        />
      </VictoryChart>
    </Card>
  );
};

export default Consumption;
